import { Grid } from "@mui/material";
import { FC } from "react";
import { H3, H4 } from "../../components/Typography";

const EsignDone: FC = () => {
  return (
    <Grid
      height="100vh"
      display="flex"
      flexDirection="column"
      sx={{
        pl: 4,
        pr: 4,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <H3
        sx={{ fontFamily: "'Poppins', sans-serif" }}
        fontWeight={600}
        fontSize={24}
      >
        Congratulations!
      </H3>
      <H4
        fontSize={16}
        sx={{ mt: 2, textAlign: "center", fontFamily: "'Poppins', sans-serif" }}
      >
        Your Esign is now complete, your digital signature has been successfully
        verified.
      </H4>
    </Grid>
  );
};

export default EsignDone;
